import Breadcrumbs from '@/components/dashboard/breadcrumbs'
import Navigation from '@/components/dashboard/navigation'
import { Separator } from '@/components/ui/separator'
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger
} from '@/components/ui/sidebar'
import { ThemeToggle } from '@/components/ui/theme'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app')({
  component: RouteComponent
})

function RouteComponent() {
  const { user } = Route.useRouteContext()

  return (
    <SidebarProvider>
      <Navigation variant="inset" user={user} />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator
            orientation="vertical"
            className="mr-2 data-[orientation=vertical]:h-2.5"
          />
          <div className="flex-1">
            <Breadcrumbs />
          </div>
          <ThemeToggle variant="outline" />
        </header>
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  )
}
